<template>
    <div class="no-user-image" :style="{ height: height, width: width }">
        <span 
            :style="{ fontSize: fontSize + 'px' }"
            :title="`${firstName} ${lastName}`">
                {{firstName.charAt(0)}}{{lastName.charAt(0)}}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        firstName: {
            type: String, 
            required: true
        },
        lastName: {
            type: String, 
            required: true
        },
        fontSize: {
            type: Number, 
            required: true
        },
        height: {
            type: String
        },
        width: {
            type: String
        }
    }
}
</script>

<style scoped>
    .no-user-image {
        width: inherit;
        height: inherit;
        border-radius: inherit;
        text-align: center;
        background-color: #000;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }

    span {
        text-transform: uppercase;
        color: #fff;
        font-weight: 100;
    }
</style>





// WEBPACK FOOTER //
// src/components/errors/NoUserImage.vue